const style = {
  paddingTop: '25px',
};


export default {
  style,
};



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/Search/style.js